import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// Changes to files aidev did not create, proposed by the server's sessions (ADR-038 section 2b)

export function useDocumentProposals(serverId: string) {
  const api = useApiClient();
  return useQuery({
    queryKey: ['document-proposals', serverId],
    queryFn: () => api.documents.proposals(serverId),
    select: (d) => d.proposals,
    refetchInterval: 30_000,
    refetchOnWindowFocus: 'always',
  });
}

export function useDecideDocument(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ proposalId, decision }: { proposalId: string; decision: 'approve' | 'reject' }) => api.documents.decide(serverId, proposalId, decision),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['document-proposals', serverId] });
      void qc.invalidateQueries({ queryKey: ['inbox', serverId] });
    },
  });
}
